
const $ = jQuery.noConflict()


class HeaderSearch { 
    constructor() { 
        this.mainHeader = document.querySelector('.main-header');
        this.searchToggle = document.querySelector('.icon-search');
    }





    static clickOffSearch (e)  { 
        if (!this.mainHeader.contains(e.target)) { 
            let searchContainer = document.querySelector('.header-search');
            if (e.target !== searchContainer) { 
                document.querySelector('.main-header').classList.remove('search-open');
            }
        }
    }



    headerSearch (e) {
    
        const isOpen = document.querySelector('.main-header').classList.contains('search-open');
        const searchInput = document.querySelector('.header-search .search-field__input');

        if ( ! isOpen ) {
            document.querySelector('.main-header').classList.add('search-open');

            if ( searchInput !== null ) {
                setTimeout(function() {
                    searchInput.focus();
                }, 100);
            }
        } else {
            document.querySelector('.main-header').classList.remove('search-open');
        }
    
    }

    bindEvents() {
        $(this.searchToggle).on('click', this.headerSearch);
    }


    init () {
        this.bindEvents();
    }

    
}


export default new HeaderSearch()